"use strict";var __importDefault=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(exports,"__esModule",{value:!0}),exports.ElementsPanel=exports.Shapes=exports.NounprojectPanel=void 0;const react_1=__importDefault(require("react")),mobx_state_tree_1=require("mobx-state-tree"),core_1=require("@blueprintjs/core"),images_grid_1=require("./images-grid"),svg_1=require("../utils/svg"),figure_to_svg_1=require("../utils/figure-to-svg"),styled_1=__importDefault(require("../utils/styled")),l10n_1=require("../utils/l10n"),use_api_1=require("../utils/use-api"),api_1=require("../utils/api"),iconToSrc=async e=>{const t=await fetch(api_1.URLS.nounProjectDownload(e)),r=await t.text();return await(0,svg_1.svgToURL)(r)},NounContainer=(0,styled_1.default)("div")`
  height: 100%;
  overflow: hidden;

  .bp5-dark & img {
    filter: invert(1);
  }
`,limit=50,NounprojectPanel=({store:e,query:t})=>{const{data:r,isLoading:a,loadMore:i,setQuery:o,hasMore:s}=(0,use_api_1.useInfiniteAPI)({defaultQuery:t,getAPI:({page:e,query:t})=>api_1.URLS.nounProjectList({query:t,page:e,limit:50}),getSize:e=>e.pagesNumber});return react_1.default.useEffect((()=>{o(t)}),[t]),react_1.default.createElement(NounContainer,null,react_1.default.createElement(images_grid_1.ImagesGrid,{shadowEnabled:!1,images:null==r?void 0:r.map((e=>e.icons)).flat(),getPreview:e=>e.preview_url_84,isLoading:a,onSelect:async(t,r,a)=>{if(a&&"image"===a.type&&a.contentEditable){const e=await iconToSrc(t.id);return void a.set({clipSrc:e})}e.history.transaction((async()=>{var a;const i=((null==r?void 0:r.x)||e.width/2)-100,o=((null==r?void 0:r.y)||e.height/2)-100,s=null===(a=e.activePage)||void 0===a?void 0:a.addElement({type:"svg",width:200,height:200,x:i,y:o}),n=await iconToSrc(t.id);(0,mobx_state_tree_1.isAlive)(s)&&await s.set({src:n})}))},rowsNumber:4,loadMore:s&&i}))};exports.NounprojectPanel=NounprojectPanel;const LINES=[{preview:svg_1.svgToURL`
<svg xmlns="http://www.w3.org/2000/svg" width="32" height="16">
  <path stroke="currentColor" strokeWidth="4" d="M 1 8 L 30 8"></path>
</svg>
`,data:{}},{preview:svg_1.svgToURL`
<svg xmlns="http://www.w3.org/2000/svg" width="32" height="16">
  <path stroke="currentColor" strokeWidth="4" stroke-dasharray="4 2" d="M 1 8 L 30 8"></path>
</svg>
`,data:{dash:[4,2]}},{preview:svg_1.svgToURL`
<svg xmlns="http://www.w3.org/2000/svg" width="32" height="16">
  <path stroke="currentColor" strokeWidth="4" stroke-dasharray="1 1" d="M 1 8 L 30 8"></path>
</svg>
`,data:{dash:[1,1]}},{preview:svg_1.svgToURL`
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="16">
    <path
      stroke="currentColor"
      strokeWidth="2"
      d="M 25 6 L 29 8 L 25 10"
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
    ></path>
    <path
      stroke="currentColor"
      strokeWidth="4" d="M 1 8 L 29 8"
      strokeLinejoin="round"
      strokeLinecap="round"
    ></path>
  </svg>
`,data:{endHead:"arrow"}},{preview:svg_1.svgToURL`
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="16">
    <path
      stroke="currentColor"
      strokeWidth="2"
      d="M 25 6 L 29 8 L 25 10 Z"
      fill="currentColor"
      strokeLinejoin="round"
      strokeLinecap="round"
    ></path>
    <path
      stroke="currentColor"
      strokeWidth="4" d="M 1 8 L 29 8"
      strokeLinejoin="round"
      strokeLinecap="round"
    ></path>
    <circle cx="3" cy="8" r="2" fill="currentColor"></circle>
  </svg>
`,data:{startHead:"circle",endHead:"arrow"}},{preview:svg_1.svgToURL`
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="16">
    <path
      stroke="currentColor"
      strokeWidth="2"
      d="M 1 6 L 5 6 L 5 10 L 1 10 Z"
      fill="currentColor"
      strokeLinejoin="round"
      strokeLinecap="round"
    ></path>
    <path
      stroke="currentColor"
      strokeWidth="4" d="M 1 8 L 29 8"
      strokeLinejoin="round"
      strokeLinecap="round"
      stroke-dasharray="2 1"
    ></path>
    <path
      stroke="currentColor"
      strokeWidth="4" d="M 29 6 L 29 10"
      strokeLinejoin="round"
      strokeLinecap="round"
    ></path>
  </svg>
`,data:{startHead:"circle",endHead:"bar",dash:[2,1]}}],Lines=({store:e})=>react_1.default.createElement(images_grid_1.ImagesGrid,{shadowEnabled:!1,rowsNumber:3,images:LINES,getPreview:e=>e.preview,itemHeight:50,isLoading:!1,onSelect:async(t,r,a)=>{const i=e.activePage.computedWidth/3;e.activePage.addElement(Object.assign({type:"line",x:r?r.x:e.activePage.computedWidth/2-i/2,y:r?r.y:e.activePage.computedHeight/2,width:i},t.data))}}),FIGURE_DEFAULTS={width:300,height:300,fill:"lightgray",stroke:"#0c0c0c",strokeWidth:0,url:""},subTypes=Object.keys(figure_to_svg_1.TYPES),DEFAULTS=[FIGURE_DEFAULTS],FIGURES=[];subTypes.forEach((e=>{DEFAULTS.forEach((t=>{FIGURES.push(Object.assign({subType:e},t))}))})),FIGURES.forEach((e=>{e.url=(0,svg_1.svgToURL)((0,figure_to_svg_1.figureToSvg)(e))}));const BasicShapesContainer=(0,styled_1.default)("div")`
  height: 220px;
  // .bp5-dark & img {
  //   filter: invert(1);
  // }
`,BasicShapes=({store:e})=>{const t=Math.ceil(FIGURES.length/4)||1;return react_1.default.createElement(BasicShapesContainer,{style:{height:110*t+"px"}},react_1.default.createElement(images_grid_1.ImagesGrid,{shadowEnabled:!1,rowsNumber:4,images:FIGURES,getPreview:e=>e.url,isLoading:!1,itemHeight:100,onSelect:async(t,r,a)=>{var i;if(a&&"image"===a.type&&a.contentEditable)return void a.set({clipSrc:t.url});const o=(e.activePage.computedWidth+e.activePage.computedHeight)/2160,s=t.width*o,n=t.height*o,l=((null==r?void 0:r.x)||e.activePage.computedWidth/2)-s/2,d=((null==r?void 0:r.y)||e.activePage.computedHeight/2)-n/2;null===(i=e.activePage)||void 0===i||i.addElement(Object.assign(Object.assign({type:"figure"},t),{x:l,y:d,width:s,height:n}))}}))},LinesContainer=(0,styled_1.default)("div")`
  height: 220px;
  .bp5-dark & img {
    filter: invert(1);
  }
`,Shapes=({store:e})=>react_1.default.createElement("div",{style:{display:"flex",flexDirection:"column",height:"100%",overflow:"auto"}},react_1.default.createElement("p",null,(0,l10n_1.t)("sidePanel.lines")),react_1.default.createElement(LinesContainer,null,react_1.default.createElement(Lines,{store:e})),react_1.default.createElement("p",null,(0,l10n_1.t)("sidePanel.shapes")),react_1.default.createElement(BasicShapes,{store:e}));exports.Shapes=Shapes;const ElementsPanel=({store:e})=>{const t=react_1.default.useRef(),[r,a]=react_1.default.useState(""),[i,o]=react_1.default.useState(r);react_1.default.useEffect((()=>(t.current=setTimeout((()=>{o(r)}),500),()=>{clearTimeout(t.current)})),[r]);const s=!!i;return react_1.default.createElement("div",{style:{height:"100%",display:"flex",flexDirection:"column"}},react_1.default.createElement(core_1.InputGroup,{leftIcon:"search",placeholder:(0,l10n_1.t)("sidePanel.searchPlaceholder"),onChange:e=>{a(e.target.value)},style:{marginBottom:"20px"},type:"search"}),s&&react_1.default.createElement(exports.NounprojectPanel,{query:i,store:e}),!s&&react_1.default.createElement(exports.Shapes,{store:e}))};exports.ElementsPanel=ElementsPanel;